import { render, staticRenderFns } from "./pointSearch.vue?vue&type=template&id=23d04c6e"
import script from "./pointSearch.vue?vue&type=script&lang=js"
export * from "./pointSearch.vue?vue&type=script&lang=js"
import style0 from "./pointSearch.vue?vue&type=style&index=0&id=23d04c6e&prod&lang=scss&rel=stylesheet%2Fscss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports